import { render, staticRenderFns } from "./OperationFileType.vue?vue&type=template&id=96f83186&scoped=true&"
import script from "./OperationFileType.vue?vue&type=script&lang=js&"
export * from "./OperationFileType.vue?vue&type=script&lang=js&"
import style0 from "./OperationFileType.vue?vue&type=style&index=0&id=96f83186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f83186",
  null
  
)

export default component.exports